<div class="main-content">
    <div class="container-fluid">
        <div class="justify-content-center row">
            <div class="col-12">
                <div class="header">
                    <div class="header-body">
                        <div class="align-items-center row">
                            <div class="col">
                                <h6 class="header-pretitle">Overview</h6>
                                <h1 class="header-title text-truncate">Taxes</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col mh-100 d-flex flex-column align-items-stretch">
                        <app-overview [query]="query" (dataChange)="data = $event" [windowScroll]="true">
                            <div class="header-bar">
                                <div class="align-items-center row gx-3 mb-4">
                                    <div class="col-auto d-flex d-md-none px-1">
                                        <button class="btn text-black p-0 btn-close-wrapper border-0 rounded-circle" (click)="openFiltersInModal()"
                                                [style.width.px]="40" [style.height.px]="40" [ngClass]="facetUtils.hasActiveFilters(facetFilters) ? 'active': ''">
                                            <span class="bi bi-filter m-0 h1"></span>
                                        </button>
                                    </div>
                                    <div class="col">
                                        <app-filter [(filterTerm)]="term" (onUpdate)="executeQuery()" placeholder="Search"></app-filter>
                                    </div>
                                    <div *ngIf="appContext.isAdminOrIntermediary()" class="col-auto">
                                        <button (click)="addTax()" type="button" class="btn btn-primary">
                                            <i class="bi bi-plus me-md-2"></i>
                                            <span class="d-none d-md-inline">Add Tax</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="d-none d-md-block">
                                    <ng-template [ngTemplateOutlet]="facetsTemplate" [ngTemplateOutletContext]="{ $implicit: 'top' }"></ng-template>
                                </div>
                            </div>
                            <div class="overview-items pb-4">
                                <div class="row mx-0">
                                    <ng-container *ngFor="let record of data; trackBy: trackByForRecord">
                                        <div role="row" class="col-xl-4 col-md-6 col-12">
                                            <app-taxes-overview-item class="h-100 d-flex" [tax]="record"></app-taxes-overview-item>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="empty-container col-12 h-100 d-flex align-items-center justify-content-center flex-column">
                                <span class="h1 mb-2">No taxes found</span>
                                <span class="text-secondary">Try adjusting your filters or search term</span>
                            </div>
                        </app-overview>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #filtersInModal>
    <div class="modal-content">
        <div class="card">
            <div class="card-header">
                <h3 class="card-header-title">
                    <i class="bi bi-filter me-2"></i>
                    <span>Filters</span>
                </h3>
            </div>
            <div class="card-body">
                <div class="position-relative w-100">
                    <ng-template [ngTemplateOutlet]="facetsTemplate" [ngTemplateOutletContext]="{ $implicit: 'left' }"></ng-template>
                </div>
            </div>
            <div class="card-footer">
                <div class="d-flex justify-content-between">
                    <a class="btn btn-secondary" data-bs-dismiss="modal">Close</a>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #facetsTemplate let-position>
    <app-facets-overview [query]="facets" (facetFiltersChange)="facetFilters = $event" [hiddenFacets]="hiddenFacets"
                         (onUpdate)="executeQuery()" localStorageKey="taxes-overview-facets" [position]="position"
                         [getValueFormatter]="facetValueFormatter" [defaultFacetFilters]="defaultFacetFilters"
                         [selectedFacets]="facetFilters"></app-facets-overview>
</ng-template>